import React, { Component } from "react";
import Taskbar from "../Taskbar";
import { getBounty } from "../../utils/bounties";
import "./Bounty.css";

export default class Bounty extends Component {
  constructor(props) {
    super(props);

    this.state = {
      address: ""
    };
  }

  componentDidMount = async () => {
    const { id } = this.props.history.location.state;
    const { data, status } = await getBounty(false, id);

    if (status === 200) {
      this.setState({
        address: data.location
      });
    }
  };

  render() {
    const {
      reward,
      location,
      image,
      title,
      reporter
    } = this.props.history.location.state;

    const { address } = this.state;

    return (
      <React.Fragment>
        <Taskbar
          title={title}
          back={() => {
            this.props.setPage(this.props.prevPath);
            this.props.history.goBack();
          }}
        />
        <div className="bounty-container">
          <div className="bounty-card-container shadowed">
            <img
              className="bounty-card-image"
              src={image}
              alt="(Trash Image Goes Here)"
            />
            <div className="bounty-card-information">
              <div className="bounty-card-title">{title}</div>
              <div className="bounty-card-location">
                {address ? (
                  <div>
                    <div>{address.split(",")[0]}</div>
                    <div>
                      {address
                        .split(",")
                        .slice(1)
                        .join(",")
                        .substr(1)}
                    </div>
                  </div>
                ) : (
                  <div>{`${location._latitude},${location._longitude}`}</div>
                )}
              </div>
              <div className="bounty-card-reward">${reward}</div>
            </div>
            <div className="bounty-card-metadata">
              <div className="bounty-card-poster">
                Posted By: {reporter.username}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
